 <template>
  <div>
    <v-dialog v-model="multi_update_tran" max-width="1200" persistent>
      <v-card :loading="loading">
        <v-card-title class="headline" style="padding-top:0px;padding-bottom:0px;">
          <v-col cols="11" style="padding-top:0px;padding-bottom:0px;">Update Selected Transactions</v-col>
          <v-col cols="1" style="padding-top:0px;padding-bottom:0px;">
            <v-btn icon>
              <v-icon size="28px" class="drag-icon">mdi-drag-variant</v-icon>
            </v-btn>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-checkbox
                dense
                v-model="update_data.update_locked_trans"
                hide-details
                label="Allow to update locked transaction(s)"
                class="mt-0 pt-0"
              ></v-checkbox>
            </v-col>
            <!-- <v-col cols="10">
              <v-autocomplete
                dense
                :items="trans_type_list"
                v-model="update_data.trans_type_id"
                outlined
                hide-details
                label="Type"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="2">
              <v-btn
                v-if="!update_data.trans_type_id"
                block
                color="error"
                @click="remove_selection_flag = 'type'; remove_selection_confirmation = true"
              >Delete</v-btn>
            </v-col>-->
            <v-col cols="3">
              <v-select
                :items="order_types"
                label="Status"
                dense
                outlined
                v-model="project_selected_status"
                @change="getProjectByStatus()"
                placeholder="All"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="7">
              <v-autocomplete
                dense
                :items="project_of_selected_status_new"
                v-model="update_data.project_id"
                outlined
                hide-details
                clearable
                @clear="project_group_list=[]"
                :label="(multiple_placeholder.project_id)?'Project (Multiple)':'Project'"
                @change="update_data.invoice_group_id = null; getGroupOfProject()"
              >
                <template v-slot:item="{ index, item }">
                  <div v-if="item.text == 'No Project'" class="v-list-item__content">
                    <div
                      class="v-list-item__title error--text"
                      style="font-size: 15px;"
                    >{{item.text}}</div>
                  </div>
                  <div v-else class="v-list-item__content">
                    <div class="v-list-item__title">{{item.text}}</div>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="2">
              <v-btn
                v-if="!update_data.project_id"
                block
                color="error"
                @click="remove_selection_flag = 'project'; remove_selection_confirmation = true"
              >Delete</v-btn>
            </v-col>
            <v-col cols="3">
              <v-select
                :items="order_types"
                label="Status"
                dense
                outlined
                v-model="vendor_selected_status"
                @change="getTransactionSelectors()"
                placeholder="All"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="7">
              <v-autocomplete
                dense
                :items="expence_list"
                v-model="update_data.vendor_id"
                outlined
                hide-details
                v-if="update_data.expence"
                clearable
                class="focus-on-vendor-expence2"
                :label="(multiple_placeholder.vendor_id)?'Chart Of Account (Multiple)':'Chart Of Account'"
                @change="update_data.invoice_group_id = null; getGroupOfProject()"
              >
                <template v-slot:prepend-item>
                  <a
                    class="pl-4"
                    @click="update_data.expence = false; setFocus('focus-on-vendor-expence2');"
                  >Select Vendor</a>
                  <v-divider></v-divider>
                </template>
              </v-autocomplete>

              <v-autocomplete
                dense
                :items="vendor_list"
                v-model="update_data.vendor_id"
                outlined
                hide-details
                clearable
                :label="(multiple_placeholder.vendor_id)?'Vendor (Multiple)':'Vendor'"
                class="focus-on-vendor-expence2"
                @change="update_data.invoice_group_id = null; getGroupOfProject()"
                v-else
              >
                <template v-slot:prepend-item>
                  <a
                    class="pl-4"
                    @click="update_data.expence = true; setFocus('focus-on-vendor-expence2');"
                  >Select Chart of Account</a>
                  <v-divider></v-divider>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="2" v-if="!update_data.vendor_id">
              <v-btn
                v-if="update_data.expence"
                block
                color="error"
                @click="remove_selection_flag = 'chart of account'; remove_selection_confirmation = true"
              >Delete</v-btn>
              <v-btn
                v-else
                block
                color="error"
                @click="remove_selection_flag = 'vendor'; remove_selection_confirmation = true"
              >Delete</v-btn>
            </v-col>

            <v-col v-else cols="2"></v-col>

            <v-col
              cols="10"
              style="display: content"
              v-if="!sales_income && only_cost_plus_type_project && !misc_type"
            >
              <v-row>
                <v-col cols="5">
                  <v-autocomplete
                    dense
                    :items="project_group_list"
                    v-model="update_data.invoice_group_id"
                    item-text="text"
                    item-value="value"
                    outlined
                    hide-details
                    clearable
                    label="Invoice Group"
                  >
                    <template v-slot:item="{ item }">
                      <span style="width: 100%">
                        <span>{{ item.text }}</span>
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              class="content-center"
              style="display: content"
              v-if="!sales_income && only_fixed_type_project && !misc_type"
            >
              <v-row>
                <v-col cols="5">
                  <v-autocomplete
                    dense
                    :items="project_group_list"
                    v-model="update_data.invoice_group_id"
                    outlined
                    hide-details
                    clearable
                    @click="sameAmountExist()"
                    @change="getGroupBalance();update_data.invoice_item_id= null;getItemOfGroup();getInvoiceListWithExpense();"
                    :readonly="multiple_placeholder.invoice_group_id"
                    :label="(multiple_placeholder.invoice_group_id)?'Invoice Group (Multiple)':'Invoice Group'"
                  >
                    <template v-slot:item="{ item }">
                      <div
                        :style="{
                        fontSize: item.type === 'sub' ? '12px' : 'inherit',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        cursor:'auto'
                      }"
                        class="pointerClass"
                      >
                        <!-- Left: Item Label -->
                        <span>{{ item.type === 'sub' ? '- ' + item.text : item.text }}</span>

                        <!-- Right: Amount with tooltip (only for 'sub' type with description) -->
                        <div class="pl-2" style="white-space: nowrap;">
                          <v-tooltip v-if="item.type === 'sub' && item.description" bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                <span
                                  class="primary--text"
                                  v-if="item.balance >= 0"
                                >${{ getAmountFormat(item.balance) }}</span>
                                <span
                                  class="error--text"
                                  v-else
                                >${{ getAmountFormat(item.balance) }}</span>
                              </span>
                            </template>
                            <span>{{ item.description }}</span>
                          </v-tooltip>

                          <!-- No tooltip fallback -->
                          <template v-else>
                            <span
                              class="primary--text"
                              v-if="item.balance >= 0"
                            >${{ getAmountFormat(item.balance) }}</span>
                            <span class="error--text" v-else>${{ getAmountFormat(item.balance) }}</span>
                          </template>
                        </div>
                      </div>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col class="col_2_width">
                  <v-checkbox
                    dense
                    v-model="check_all_group"
                    hide-details
                    label="All Group"
                    class="mt-0 pt-0"
                    @click="getGroupOfProject()"
                  ></v-checkbox>
                </v-col>
                <div class="col_110 p-5">
                  <v-btn
                    :disabled="!update_data.invoice_group_id"
                    block
                    color="error"
                    @click="remove_selection_flag = 'invoice group'; remove_selection_confirmation = true"
                  >Delete</v-btn>
                </div>
                <div class="col_110" v-if="update_data.invoice_group_id && group_balance_data[0]">
                  <b>Cost</b>
                  <br />
                  ${{group_balance_data[0] ? group_balance_data[0].cost : ''}}
                </div>
                <div class="col_110" v-if="update_data.invoice_group_id && group_balance_data[0]">
                  <b>Balance</b>
                  <br />$
                  <span
                    ref="groupAmount"
                  >{{group_balance_data[0] ? group_balance_data[0].balance : ''}}</span>
                </div>
                <div class="col_110" v-if="update_data.invoice_group_id && group_balance_data[0]">
                  <b>Money spent</b>
                  <br />
                  <span
                    :class="getMoneySpent < 0 ? 'error--text': 'primary--text'"
                  >${{getAmountFormat(getMoneySpent)}}</span>
                </div>
                <div class="col_110" v-if="update_data.invoice_group_id && group_balance_data[0]">
                  <b>Balance to Spend</b>
                  <br />
                  <span
                    class="primary--text"
                    v-if="getBalanceToSpand >= 0"
                  >${{getAmountFormat(getBalanceToSpand)}}</span>
                  <span
                    class="error--text"
                    v-if="getBalanceToSpand < 0"
                  >${{getAmountFormat(getBalanceToSpand)}}</span>
                </div>
              </v-row>
              <v-row>
                <v-col cols="5">
                  <v-autocomplete
                    dense
                    :items="project_item_list"
                    v-model="update_data.invoice_item_id"
                    item-text="text"
                    item-value="value"
                    outlined
                    hide-details
                    clearable
                    :label="(multiple_placeholder.invoice_item_id)?'Invoice Item (Multiple)':'Invoice Item'"
                    v-if="!multiple_placeholder.invoice_group_id"
                    @change="getItemBalance();"
                  >
                    <template v-slot:item="{ item }">
                      <span style="width: 100%; display: flex; justify-content: space-between;">
                        <span>
                          {{ item.text }} -
                          <span style="font-size:12px;">({{ item.area }})</span>
                        </span>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="pl-2">
                              <span
                                class="primary--text"
                                v-if="item.balance >= 0"
                              >${{ getAmountFormat(item.balance) }}</span>
                              <span class="error--text" v-else>${{ getAmountFormat(item.balance) }}</span>
                            </span>
                          </template>
                          <span>{{ item.description }}</span>
                        </v-tooltip>
                      </span>
                    </template>git
                  </v-autocomplete>
                </v-col>
                <v-col class="col_2_width"></v-col>
                <div class="col_110 p-5">
                  <v-btn
                    :disabled="!update_data.invoice_item_id"
                    block
                    color="error"
                    @click="remove_selection_flag = 'invoice item'; remove_selection_confirmation = true"
                  >Delete</v-btn>
                </div>
                <div class="col_110" v-if="update_data.invoice_item_id && item_balance_data[0]">
                  <b>Cost</b>
                  <br />
                  ${{item_balance_data[0] ? item_balance_data[0].cost : ''}}
                </div>
                <div class="col_110" v-if="update_data.invoice_item_id && item_balance_data[0]">
                  <b>Balance</b>
                  <br />$
                  <span
                    ref="groupAmount"
                  >{{item_balance_data[0] ? item_balance_data[0].balance : ''}}</span>
                </div>
                <div class="col_110" v-if="update_data.invoice_item_id && item_balance_data[0]">
                  <b>Money spent</b>
                  <br />
                  <span
                    :class="getItemMoneySpent < 0 ? 'error--text': 'primary--text'"
                  >${{getAmountFormat(getItemMoneySpent)}}</span>
                </div>
                <div class="col_110" v-if="update_data.invoice_item_id && item_balance_data[0]">
                  <b>Balance to Spend</b>
                  <br />
                  <span
                    class="primary--text"
                    v-if="getItemBalanceToSpand >= 0"
                  >${{getAmountFormat(getItemBalanceToSpand)}}</span>
                  <span
                    class="error--text"
                    v-if="getItemBalanceToSpand < 0"
                  >${{getAmountFormat(getItemBalanceToSpand)}}</span>
                </div>
              </v-row>

              <v-row v-if="!sales_income &&  is_expense_list==true">
                <v-col cols="5">
                  <v-autocomplete
                    dense
                    :items="invoice_expense_list"
                    v-model="update_data.expense_invoice_id"
                    item-text="invoice_number"
                    item-value="generated_inv_id"
                    outlined
                    hide-details
                    clearable
                    :label="(multiple_placeholder.expense_invoice_id)?'Invoice  (Multiple)':'Invoice '"
                    v-if="!multiple_placeholder.invoice_group_id"
                    @change="getExpenseBalanceWithInvoice();"
                  >
                    <template v-slot:item="{ item }">
                      <span style="width: 100%">
                        <span>{{ item.invoice_number }} - ( {{item.invoice_date}} )</span>
                        <span class="float-right pl-2">
                          <span class="primary--text" v-if="item.balance >= 0">${{ (item.balance) }}</span>
                          <span class="error--text" v-if="item.balance < 0">${{ (item.balance) }}</span>
                        </span>
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col class="col_2_width"></v-col>
                <v-col class="col_110"></v-col>
                <!-- <v-col cols="2">
                  <v-btn
                    v-if="!update_data.expense_invoice_id"
                    block
                    color="error"
                    @click="remove_selection_flag = 'invoice item'; remove_selection_confirmation = true"
                  >Delete</v-btn>
                </v-col>-->

                <div
                  class="col_110"
                  v-if="update_data.expense_invoice_id && expense_balance_data[0]"
                >
                  <b>Invoice Amount</b>
                  <br />
                  ${{expense_balance_data[0] ? expense_balance_data[0].amount : ''}}
                </div>
                <div
                  class="col_110"
                  v-if="update_data.expense_invoice_id && expense_balance_data[0]"
                >
                  <b>Balance To Assign</b>
                  <br />$
                  <span
                    ref="groupAmount"
                  >{{expense_balance_data[0] ? expense_balance_data[0].balance : ''}}</span>
                </div>
                <div
                  class="col_110"
                  v-if="update_data.expense_invoice_id && expense_balance_data[0]"
                >
                  <b>Assigned</b>
                  <br />
                  <span
                    :class="getInvoiceExpenseMoneySpent < 0 ? 'error--text': 'primary--text'"
                  >${{getAmountFormat(getInvoiceExpenseMoneySpent)}}</span>
                </div>
                <div
                  class="col_110"
                  v-if="update_data.expense_invoice_id && expense_balance_data[0]"
                >
                  <b>Balance</b>
                  <br />
                  <span
                    class="primary--text"
                    v-if="getInvoiceExpenseBalanceToSpand >= 0"
                  >${{getAmountFormat(getInvoiceExpenseBalanceToSpand)}}</span>
                  <span
                    class="error--text"
                    v-if="getInvoiceExpenseBalanceToSpand < 0"
                  >${{getAmountFormat(getInvoiceExpenseBalanceToSpand)}}</span>
                </div>
              </v-row>
            </v-col>

            <v-col cols="6">
              <v-menu
                v-model="transaction_date"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="update_data.transaction_date"
                    :label="(multiple_placeholder.transaction_date)?'Transaction Date (Multiple)':'Transaction Date'"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    hide-details
                    outlined
                    clearable
                    :disabled="update_data.is_lock_by_current_date == 1"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateFormatted"
                  @input="transaction_date = false; parseDate2()"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                :label="(multiple_placeholder.bank_id)?'Bank (Multiple)':'Bank'"
                :items="banks"
                v-model="update_data.bank_id"
                hide-details
                item-text="bank_name"
                item-value="bank_id"
                :disabled="update_data.is_lock_by_current_date == 1"
                outlined
                clearable
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="3" class="d-flex align-center">
              <v-radio-group
                v-model="update_data.amount_type"
                row
                hide-details
                class="mt-0"
                dense
                :disabled="update_data.is_lock_by_current_date == 1"
              >
                <v-radio color="primary" value="PLUS" class="ma-0 pa-0">
                  <template v-slot:label>
                    <div class="primary--text">Cr</div>
                  </template>
                </v-radio>
                <v-radio label="Dr" color="error" value="MINUS" class="ma-0 pa-0 pl-2">
                  <template v-slot:label>
                    <div class="error--text">Dr</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
            <v-col
              cols="2"
              class="d-flex align-center pl-0"
              v-if="multiple_placeholder.amount_type"
            >(Multiple)</v-col>
            <v-col
              v-if="update_data.amount_type && selected_items.length > 1"
              cols="1"
              class="d-flex align-center pl-0"
              style="max-width: 11%;"
            >
              <a @click="update_data.amount_type = null;">Clear</a>
            </v-col>
            <v-col cols="4">
              <v-text-field
                label="Amount"
                v-model="update_data.amount"
                v-if="selected_items.length == 1"
                hide-details
                type="number"
                :color="(update_data.amount_type == 'MINUS')?'error':'primary'"
                :class="(update_data.amount_type == 'MINUS')?'red-font-color':'green-font-color'"
                outlined
                dense
                :disabled="update_data.is_lock_by_current_date == 1"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <b>Total Transaction Amount:</b>
              <span
                v-if="getTotalOfSelectedTransaction >= 0"
                class="primary--text"
              >${{getAmountFormat(getTotalOfSelectedTransaction)}}</span>
              <span v-else class="error--text">${{getAmountFormat(getTotalOfSelectedTransaction)}}</span>
            </v-col>
            <v-col cols="12" v-if="!sales_income && only_fixed_type_project">
              <b>Total Invoice Amount:</b>
              <span
                v-if="getInvoiceTotalOfSelectedTransaction >= 0"
                class="primary--text"
              >${{getAmountFormat(getInvoiceTotalOfSelectedTransaction)}}</span>
              <span
                v-else
                class="error--text"
              >${{getAmountFormat(getInvoiceTotalOfSelectedTransaction)}}</span>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn color="error" @click="closePopup()">Cancel</v-btn>
          <v-spacer></v-spacer>
          <!-- {{getBalanceToSpand}}aaaaa{{getItemBalanceToSpand}} -->
          <v-btn
            color="primary"
            :disabled="getBalanceToSpand < 0 || getItemBalanceToSpand < 0"
            @click="updateTransactions"
          >Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="remove_selection_confirmation" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete {{remove_selection_flag}} on selected transactions?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="remove_selection_confirmation = false">Cancel</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="remove_selection_confirmation = false; removeSelection()"
          >Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="is_same_account_type_exist"
      max-width="400"
      style="z-index:999999999999 !important;"
    >
      <v-card>
        <v-card-title class="headline">Alert</v-card-title>
        <v-card-text>Please select Credit only or Debit only Transaction</v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
 <script>
import axios from "../../plugins/axios";
import { mapMutations } from "vuex";
import { getTotalOrderAmountwithAllcalculation } from "../../plugins/helper";
export default {
  data() {
    return {
      loading: false,
      check_all_group: true,
      update_data: {
        trans_type_id: null,
        project_id: null,
        invoice_group_id: null,
        update_locked_trans: false,
        vendor_id: null,
        expence: false,
        transaction_date: null,
        amount_type: null,
        amount: null,
        bank_id: null,
        invoice_item_id: null,
        expense_invoice_id: null
      },
      is_expense_list: false,
      invoice_expense_list: [],
      expense_balance_data: [],
      transaction_date: false,
      project_placeholder: "Project",
      vendor_placeholder: "Vendor",
      item_placeholder: "Item",
      transaction_date_placeholder: "Transaction Date",
      bank_placeholder: "Bank",
      cr_dr_placeholder: "",
      multiple_placeholder: {
        project_id: false,
        invoice_group_id: false,
        invoice_item_id: false,
        vendor_id: false,
        transaction_date: false,
        bank_id: false,
        amount_type: false,
        expense_invoice_id: false
      },
      dateFormatted: null,
      misc_type: false,
      project_of_selected_status_new: [],
      project_group_list: [],
      project_selected_status: "1",
      vendor_selected_status: "all",
      trans_type_list: [],
      expence_list: [],
      item_list: [],
      vendor_list: [],
      group_balance_data: [],
      banks: [],
      order_types: [
        { text: "All", value: "all" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" }
      ],
      remove_selection_flag: null,
      remove_selection_confirmation: false,
      is_same_account_type_exist: false,
      unique_account_type: "2",
      project_item_list: [],
      item_balance_data: [],
      sales_income: false,
      diffrent_type_project: false,
      only_fixed_type_project: false,
      only_cost_plus_type_project: false
    };
  },
  props: ["multi_update_tran", "selected_items", "project_of_selected_status"],
  watch: {
    multi_update_tran: function(value) {
      if (value) {
        this.sales_income = false;
        this.check_all_group = true;
        // this.project_selected_status = "all";
        this.project_of_selected_status_new = this.project_of_selected_status;

        this.update_data.project_id = this.selected_items[0].project_id;

        let status = "1";
        if (this.selected_items[0].project_id == "") {
          status = "1";
        } else {
          let project_status = this.selected_items[0]?.project?.p_active;
          if (project_status == true) {
            status = "1";
          } else {
            status = "0";
          }
        }

        this.project_selected_status = status;
        this.getProjectByStatus();

        if (this.selected_items.length == 1) {
          this.update_data.amount = this.getAmountFormat(
            this.selected_items[0].rev_amount
          );
        } else {
          this.update_data.amount = null;
        }

        this.update_data.is_lock_by_current_date = 0;
        this.selected_items.filter(item => {
          if (item.is_lock_by_current_date == 1) {
            this.update_data.is_lock_by_current_date = 1;
          }
        });
        let count = 0;
        let fixed_count = 0;
        let cost_plus_count = 0;
        let misc_type = 0;

        this.selected_items.filter(item => {
          console.log(item, "misc_type");
          if (item.vendor_id == 35 && item.expence == true) {
            count++;
          }
          if (item.project && item.project.p_type == "fixed") {
            fixed_count++;
          }
          if (item.project && item.project.p_type == "cost_plus") {
            cost_plus_count++;
          }
          if (
            item.project &&
            (item.project.project_work[0].project_work == "counter_tops" ||
              item.project.project_work[0].project_work == "retail_sales")
          ) {
            misc_type++;
          }
        });
        if (count > 0) {
          this.sales_income = true;
        }
        if (fixed_count > 0 && cost_plus_count > 0) {
          this.diffrent_type_project = true;
          this.only_cost_plus_type_project = false;
          this.only_fixed_type_project = false;
        }
        if (fixed_count == 0 && cost_plus_count > 0) {
          this.only_cost_plus_type_project = true;
          this.only_fixed_type_project = false;
        }
        if (fixed_count > 0 && cost_plus_count == 0) {
          this.only_fixed_type_project = true;
          this.only_cost_plus_type_project = false;
        }
        if (misc_type > 0) {
          this.misc_type = true;
        }
        console.log(this.misc_type, "this.misc_type");

        this.update_data.trans_type_id = null;
        this.update_data.update_locked_trans = false;

        this.multiple_placeholder = {
          project_id: false,
          invoice_group_id: false,
          invoice_item_id: false,
          vendor_id: false,
          transaction_date: false,
          bank_id: false,
          amount_type: false,
          expense_invoice_id: false
        };

        this.update_data.invoice_group_id =
          this.selected_items[0].change_order +
          "-" +
          this.selected_items[0].invoice_group_id;
        this.update_data.invoice_item_id = this.selected_items[0].invoice_item_id;
        this.update_data.expense_invoice_id = this.selected_items[0].generated_inv_id;
        this.update_data.vendor_id = this.selected_items[0].vendor_id;
        this.update_data.expence = this.selected_items[0].expence;
        this.dateFormatted = this.selected_items[0].trans_date;
        this.parseDate2();
        this.update_data.bank_id = this.selected_items[0].bank_id;
        if (this.selected_items[0].rev_amount < 0) {
          this.update_data.amount_type = "MINUS";
        } else {
          this.update_data.amount_type = "PLUS";
        }
        this.setDefaultvalue("project_id", "project_id");
        this.setDefaultvalue("invoice_group_id", "invoice_group_id");
        this.setDefaultvalue("invoice_item_id", "invoice_item_id");
        this.setDefaultvalue("vendor_id", "vendor_id");
        this.setDefaultvalue("trans_date", "transaction_date");
        this.setDefaultvalue("bank_id", "bank_id");
        this.setDefaultvalue("rev_amount", "amount_type");
        this.setDefaultvalue("generated_invoice_id", "expense_invoice_id");

        setTimeout(() => {
          this.getGroupOfProject();
          this.getTransactionSelectors();
        }, 3000);
      }
    }
  },
  computed: {
    getMoneySpent() {
      if (this.group_balance_data[0] && this.only_fixed_type_project) {
        let money_spent =
          parseFloat(this.group_balance_data[0].money_spent) +
          parseFloat(this.getTotalOfSelectedTransaction);
        let grp_id = this.update_data.invoice_group_id.split("-");

        if (
          !this.multiple_placeholder.invoice_group_id &&
          this.selected_items[0].invoice_group_id == grp_id[1]
        ) {
          money_spent =
            parseFloat(money_spent) -
            parseFloat(this.getTotalOfSelectedTransaction);
        }

        return money_spent.toFixed(2);
      } else {
        return "";
      }
    },
    getBalanceToSpand() {
      if (this.group_balance_data[0] && this.only_fixed_type_project) {
        let balance =
          parseFloat(this.group_balance_data[0].cost) +
          parseFloat(this.getMoneySpent);
        return balance.toFixed(2);
      } else {
        return "";
      }
    },

    getItemMoneySpent() {
      let money_spent_item;
      money_spent_item =
        parseFloat(this.item_balance_data[0].money_spent) +
        parseFloat(this.getTotalOfSelectedTransaction);
      let item_id = this.update_data.invoice_item_id;

      if (
        !this.multiple_placeholder.invoice_group_id &&
        this.selected_items[0].invoice_item_id == item_id
      ) {
        money_spent_item =
          parseFloat(money_spent_item) -
          parseFloat(this.getTotalOfSelectedTransaction);
      }

      return money_spent_item.toFixed(2);
    },
    getItemBalanceToSpand() {
      if (this.item_balance_data[0] && this.only_fixed_type_project) {
        let balance_item;
        balance_item =
          parseFloat(this.item_balance_data[0].cost) +
          parseFloat(this.getItemMoneySpent);
        return balance_item.toFixed(2);
      } else {
        return "";
      }
    },
    getTotalOfSelectedTransaction() {
      if (this.selected_items && this.selected_items.length > 0) {
        let total = 0;
        this.selected_items.filter(item => {
          total = parseFloat(total) + parseFloat(item.rev_amount);
        });
        return total.toFixed(2);
      } else {
        return "";
      }
    },
    getInvoiceTotalOfSelectedTransaction() {
      if (this.selected_items && this.selected_items.length > 0) {
        let total = 0;
        this.selected_items.filter(item => {
          total = parseFloat(total) + parseFloat(item.rev_amount);
        });
        total = this.getInvoiceAmt(this.selected_items[0], total);
        return total.toFixed(2);
      } else {
        return "";
      }
    },

    getInvoiceExpenseMoneySpent() {
      let money_spent;
      money_spent =
        parseFloat(this.expense_balance_data[0].money_spent) +
        parseFloat(this.getInvoiceTotalOfSelectedTransaction);

      let invoice_id = this.update_data.expense_invoice_id;
      if (
        !this.multiple_placeholder.expense_invoice_id &&
        invoice_id == this.selected_items[0].generated_inv_id
      ) {
        money_spent =
          parseFloat(money_spent) +
          parseFloat(this.getInvoiceTotalOfSelectedTransaction);
      }
      return money_spent.toFixed(2);
    },
    getInvoiceExpenseBalanceToSpand() {
      if (this.expense_balance_data[0]) {
        let balance;
        balance =
          parseFloat(this.expense_balance_data[0].amount) +
          parseFloat(this.getInvoiceExpenseMoneySpent);
        return balance.toFixed(2);
      } else {
        return "";
      }
    }
  },
  components: {},
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    getInvoiceAmt(item, amount = "") {
      console.log(amount, "amount");
      let val = amount ? amount : item.rev_amount;
      let total = this.getAmountFormat(val);
      total = getTotalOrderAmountwithAllcalculation(
        item.project.p_price,
        item.project.multiplier,
        val
      );
      return total;
    },
    copyGroupAmount() {
      this.selectText(this.$refs.groupAmount); // e.g. <div ref="text">
      document.execCommand("copy");
    },
    selectText(element) {
      var range;
      if (document.selection) {
        // IE
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },

    sameAmountExist() {
      // if(this.unique_account_type=='2'){
      // this.project_group_list=[];
      // this.is_same_account_type_exist=true;
      // }
    },
    getGroupBalance() {
      // if(this.unique_account_type=='1'){
      this.group_balance_data = this.project_group_list.filter(item => {
        if (item.value == this.update_data.invoice_group_id) {
          return item;
        }
      });
      // }
    },
    getItemBalance() {
      this.item_balance_data = this.project_item_list.filter(item => {
        if (item.value == this.update_data.invoice_item_id) {
          return item;
        }
      });
    },
    getExpenseBalanceWithInvoice() {
      if (this.update_data.expense_invoice_id) {
        this.expense_balance_data = this.invoice_expense_list.filter(item => {
          if (item.generated_inv_id == this.update_data.expense_invoice_id) {
            return item;
          }
        });
      } else {
        this.update_data.invoice_id = null;
      }
    },

    getGroupOfProject() {
      if (
        this.update_data.project_id != null &&
        this.update_data.project_id != ""
      ) {
        let _self = this;
        // this.loading = true;
        let data = [];
        this.selected_items.map(function(item) {
          if (item.rev_amount < 0) {
            item.amount_type = "MINUS";
          } else {
            item.amount_type = "PLUS";
          }
          data.push(item.amount_type);
          return item;
        });
        var unique = data.filter(function(itm, i, data) {
          return i == data.indexOf(itm);
        });
        this.unique_account_type = unique.length;

        axios
          .get(
            "get_group_of_project_with_balance?project_id=" +
              this.update_data.project_id +
              "&vendor_id=" +
              this.update_data.vendor_id +
              "&check_all_group=" +
              this.check_all_group +
              "&amount_type=" +
              unique[0]
          )
          .then(response => {
            if (response.data.status) {
              // _self.loading = false;
              _self.project_group_list = response.data.data;
              _self.project_group_list = _self.project_group_list.filter(
                item => {
                  let grp_cha = item.value;
                  let val = grp_cha.split("-");
                  if (
                    item.balance != 0.0 ||
                    (!_self.multiple_placeholder.invoice_group_id &&
                      this.selected_items[0].invoice_group_id == val[1] &&
                      _self.selected_items[0].change_order == val[0])
                  ) {
                    return item;
                  }
                }
              );

              let transformedList = [];
              this.project_group_list.forEach(group => {
                let mainGroup = {
                  value: group.value,
                  change_order: group.change_order,
                  text: group.text,
                  cost: group.cost,
                  money_spent: group.money_spent,
                  balance: group.balance,
                  type: "main"
                };

                transformedList.push(mainGroup);
                group.items.forEach(item => {
                  let subItem = {
                    ...item,
                    type: "sub",
                    disabled: true
                  };
                  if (item.balance != 0.0) {
                    transformedList.push(subItem);
                  }
                });
              });
              _self.project_group_list = transformedList;
              _self.getGroupBalance();
              _self.getItemOfGroup();
              _self.getInvoiceListWithExpense();
            }
          })
          .catch(function() {});
      }
    },
    getItemOfGroup() {
      console.log(
        this.update_data.invoice_group_id,
        "this.update_data.invoice_group_id"
      );
      if (
        this.update_data.invoice_group_id != "0-null" &&
        this.update_data.invoice_group_id != "null-null"
      ) {
        let _self = this;
        // _self.loading = true;
        axios
          .get(
            "get_item_of_group_with_balance?project_id=" +
              this.update_data.project_id +
              "&project_data_id=" +
              this.update_data.invoice_item_id +
              "&vendor_id=" +
              this.update_data.vendor_id +
              "&group_id=" +
              this.update_data.invoice_group_id +
              "&check_all_group=" +
              this.check_all_group +
              "&amount_type=" +
              this.update_data.amount_type
          )
          .then(response => {
            if (response.data.status) {
              _self.project_item_list = response.data.data;
            }
            _self.project_item_list = _self.project_item_list.filter(item => {
              if (
                item.balance != 0.0 ||
                (!_self.multiple_placeholder.invoice_item_id &&
                  this.selected_items[0].invoice_item_id == item.value)
              ) {
                return item;
              }
            });
            // _self.loading = false;
            _self.getItemBalance();
          })
          .catch(function() {});
      }
    },
    getInvoiceListWithExpense() {
      let _self = this;
      this.loading = true;
      axios
        .get(
          "get_invoice_of_group_with_expense?project_id=" +
            this.update_data.project_id +
            "&project_data_id=" +
            this.update_data.invoice_item_id +
            "&vendor_id=" +
            this.update_data.vendor_id +
            "&group_id=" +
            this.update_data.invoice_group_id +
            "&check_all_group=" +
            this.check_all_group +
            "&amount_type=" +
            this.update_data.amount_type
        )
        .then(response => {
          if (response.data.status) {
            _self.invoice_expense_list = response.data.data;
            _self.invoice_expense_list = _self.invoice_expense_list.filter(
              item => {
                if (item.balance != 0.0) {
                  return item;
                }
              }
            );
            if (_self.invoice_expense_list.length > 0) {
              this.is_expense_list = true;
            }
          }
          _self.loading = false;
          _self.getExpenseBalanceWithInvoice();
        })
        .catch(function() {});
    },

    setDefaultvalue(field_name, field_name2) {
      this.selected_items.filter(item => {
        if (field_name == "vandor_id") {
          if (
            item[field_name] != this.selected_items[0][field_name] ||
            item.expence != this.selected_items[0].expence
          ) {
            this.update_data[field_name2] = "";
            this.update_data.expence = "";
          }
        } else if (field_name == "rev_amount") {
          if (this.selected_items[0].rev_amount < 0) {
            if (item.rev_amount > 0) {
              this.update_data.amount_type = "";
            }
          } else {
            if (item.rev_amount < 0) {
              this.update_data.amount_type = "";
            }
          }
        } else {
          if (item[field_name] != this.selected_items[0][field_name]) {
            this.update_data[field_name2] = "";
          }
        }

        if (item[field_name]) {
          this.multiple_placeholder[field_name2] = true;
        }
      });
      if (this.update_data[field_name2]) {
        this.multiple_placeholder[field_name2] = false;
      }
      // if(this.multiple_placeholder.vendor_id) {
      //   this.check_all_group = true
      // } else {
      //   this.check_all_group = false
      // }
    },
    updateTransactions() {
      let _self = this;
      this.loading = true;
      let ids = [];
      this.selected_items.map(function(item) {
        ids.push(item.trans_id);
      });
      this.update_data.ids = ids;
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      this.update_data.company_id = company_data.company_id;
      this.update_data.invoice_amt = this.update_data.expense_invoice_id
        ? Math.abs(this.getInvoiceTotalOfSelectedTransaction)
        : null;

      axios
        .post("update_transactions", this.update_data)
        .then(function(response) {
          if (response.data.lock_tran_count > 0) {
            _self.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
          }
          _self.loading = false;
          _self.$emit("updateValue");
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    getAmountFormat(value) {
      if (value) {
        return String(value).replace("-", "");
      } else {
        return 0;
      }
    },
    closePopup() {
      this.$emit("closePopup");
    },
    parseDate2() {
      const [year, month, day] = this.dateFormatted.split("-");
      this.update_data.transaction_date = `${month.padStart(
        2,
        "0"
      )}/${day.padStart(2, "0")}/${year}`;
    },
    setFocus(className) {
      document.querySelectorAll("." + className + " input")[0].focus();
    },
    removeSelection() {
      let _self = this;
      this.loading = true;
      let ids = [];
      this.selected_items.map(function(item) {
        ids.push(item.trans_id);
      });
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);

      axios
        .post("remove_selection", {
          ids: ids,
          flag: this.remove_selection_flag,
          company_id: company_data.company_id
        })
        .then(function(response) {
          //_self.getTransaction();
          _self.setAlert({
            show: true,
            variant: "primary",
            message: response.data.message,
            dismissCountDown: 0
          });
          _self.loading = false;
          _self.$emit("deleteSelection", _self.remove_selection_flag);
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    getProjectByStatus() {
      let _self = this;
      this.loading = true;
      axios
        .get("get_project_by_status?status=" + this.project_selected_status)
        .then(response => {
          if (response.data.status) {
            _self.project_of_selected_status_new = response.data.data;
          }
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    getTransactionSelectors() {
      let _self = this;
      // this.loading = true;
      axios
        .get("update_transaction_data?status=" + this.vendor_selected_status)
        .then(response => {
          if (response.data.status) {
            _self.trans_type_list = response.data.data.trans_types;
            _self.expence_list = response.data.data.expences;
            _self.item_list = response.data.data.items;
            _self.vendor_list = response.data.data.vendors;
            _self.banks = response.data.data.banks;
          }
          // _self.loading = false;
        })
        .catch(function() {});
    }
  },
  created: function() {},
  mounted: function() {
    this.diffrent_type_project = false;
    this.only_fixed_type_project = false;
    this.only_cost_plus_type_project = false;
  }
};
</script>
 <style scoped>
.content-center {
  display: content !important;
}
.col_110 {
  width: 115px;
  margin-top: 10px;
}
.col_150 {
  width: 130px;
  margin-top: 10px;
}
.col_2_width {
  max-width: 9% !important;
  width: 9% !important;
}
.p-5 {
  padding-left: 5px;
  padding-right: 5px;
}
.pointerClass {
  pointer-events: auto !important;
}
</style>